// Standalone SVG, one file per toast state. Uses currentColor so the SCSS
// (via --toast-accent) drives the colour — never hardcode a colour here.
// The continuous spin is applied by `.toast__icon--spin` in the SCSS.
const LoadingIcon = ({ size = 24 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    stroke="currentColor"
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M10 3 A7 7 0 1 1 3 10" />
  </svg>
)

export default LoadingIcon
